import { isPlatformBrowser } from '@angular/common';
import { CSP_NONCE, Inject, Injectable, PLATFORM_ID } from '@angular/core';

/**
 * Service to automatically add nonce to dynamically created style elements
 * This ensures Angular Material and other dynamic styles comply with CSP
 */
@Injectable({
    providedIn: 'root',
})
export class CspStyleNonceService {
    private nonce: string;
    private observer: MutationObserver | null = null;

    constructor(@Inject(CSP_NONCE) nonce: string, @Inject(PLATFORM_ID) private platformId: Object) {
        this.nonce = nonce;
    }

    /**
     * Initialize the service to watch for dynamically created style elements
     */
    initialize(): void {
        if (!isPlatformBrowser(this.platformId) || !this.nonce) {
            return;
        }

        // Add nonce to existing style elements that might have missed the global __CSP_NONCE__
        this.addNonceToExistingStyles();
    }

    /**
     * Add nonce to all existing style elements that don't have it
     */
    private addNonceToExistingStyles(): void {
        const styles = document.querySelectorAll('style:not([nonce])');
        styles.forEach(style => {
            if (!style.hasAttribute('nonce')) {
                style.setAttribute('nonce', this.nonce);
            }
        });
    }

    /**
     * Clean up observers
     */
    destroy(): void {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }
}
